module.exports = "/static/media/article04.6bc0ec9a.jpg";